import React, { Component } from 'react';
import Select from 'react-select';
import { connect } from 'react-redux';
import { FormGroup, ControlLabel, FormControl } from 'react-bootstrap';
import { actions } from 'react-redux-form';
import _ from 'lodash';
import hash from 'object-hash';
import PropTypes from 'prop-types';

import 'react-select/dist/react-select.css'
import './multi-select.css'

class MultiSelect extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value:   [],
      options: []
    }
  }

  componentWillReceiveProps(nextProps) {
    let { options, value } = this.state;

    if (this.props.withAllOption && nextProps.data.length) {
      nextProps.data.unshift({ label: 'All', value: 'all' });
    }

    const transformedOptions = this.renderOptions(nextProps.data);
    let transformedValue = this.renderOptions(nextProps.value);

    if (hash(options, { excludeValues: true }) !== hash(transformedOptions, {excludeValues: true}) ||
      hash(value, { excludeValues: true }) !== hash(transformedValue, {excludeValues: true})) {

      if (value.length) {
        transformedValue = value;
      } else if (transformedOptions.length) {
        transformedValue = transformedOptions.filter(val => transformedValue.find(otherVal => val.value == otherVal.value));
      }

      this.setState({
        options: transformedOptions,
        value: transformedValue
      });

      if (this.props.model) {
        this.props.dispatch(actions.change(this.props.model, transformedValue))
      }
    }
  }

  componentDidMount() {
    const { value, data } = this.props;

    this.componentWillReceiveProps({ value: value, data: data });
  }

  componentWillUnmount() {
    this.setState({
      value: [],
      options: []
    });
  }

  handleChange(val) {
    const { model, dispatch } = this.props;

    if (this.props.withAllOption && val.some(item => item.value === "all")) {
      val = val.filter(item => item.value === "all");
    }

    this.setState({ value: val }, () => {
      if (!val.length && model) {
        dispatch(actions.change(model, []));
      } else if (model) {
        dispatch(actions.change(model, val));
      }

      if (this.props.onChange && this.props.onChange !== undefined) {
        this.props.onChange(val);
      }
    });
  }

  renderOptions = (values) => {
    const { valueAttr, labelAttr } = this.props;

    if (_.isPlainObject(values)) {
      return (
        Object.keys(values).map(item => {
          return ({label: values[item], value: item})
        })
      );
    } else {
      return (
        values.map(item => {
          if (_.isPlainObject(item)) {
            if (item.hasOwnProperty('label') && item.hasOwnProperty('value')) {
              return item;
            }
            return ({label: _.get(item, labelAttr), value: _.get(item, valueAttr)})
          } else {
            return ({label: item, value: item})
          }
        })
      );
    }
  };

  renderArrow = ({onMouseDown, isOpen}) => {
    if (isOpen) {
      return (
        <i className="fa fa-angle-up"/>
      )
    } else {
      return (
        <i className="fa fa-angle-down"/>
      );
    }
  };

  render() {
    return (
      <FormGroup className="multiselect-formgroup" controlId={this.props.controlId}>
        {this.props.label && <ControlLabel>{this.props.label}</ControlLabel>}
        <Select placeholder={this.props.placeholder}
                className="form-control"
                value={this.state.value}
                options={this.state.options}
                arrowRenderer={this.renderArrow}
                clearable={false}
                cache={false}
                disabled={this.props.disabled}
                autoBlur
                closeOnSelect
                onChange={(option) => this.handleChange(option)}
                multi={true}
                searchable={this.props.searchable}/>
        <FormControl.Feedback/>
      </FormGroup>
    )
  }
}

MultiSelect.propTypes = {
  model:          PropTypes.string,
  label:          PropTypes.string,
  data:           PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object]).isRequired,
  labelAttr:      PropTypes.string,
  valueAttr:      PropTypes.string,
  controlId:      PropTypes.string,
  placeholder:    PropTypes.string,
  searchable:     PropTypes.bool,
  disabled:       PropTypes.any,
  withAllOption:  PropTypes.bool
};

MultiSelect.defaultProps = {
  labelAttr:      'label',
  valueAttr:      'value',
  controlId:      Math.random().toString(16).substring(2),
  searchable:     true,
  withAllOption:  false
};

export default connect()(MultiSelect);



// WEBPACK FOOTER //
// ./src/components/common/form/multi-select.jsx